class Alert {
  constructor(params) {
    this.id = params.id;
    this.lines = params.lines || [];
  }
}

export { Alert };



// WEBPACK FOOTER //
// ./src/models/Alert.js